import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { FormGroup, AbstractControl, FormControl, Validators } from '@angular/forms'; 
import { department, interaction, division, user, usermaster, tenant, userpermission } from './../../models/admin';
import { Users, usergroup, page, userrights } from './../../models/users';
import { AdminApiService } from './../../services/admin.service';
import { UtilityService } from './../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
//import { MatSliderChange } from '@angular/material/slider';
//import { Query } from '@syncfusion/ej2-data';
import Swal from 'sweetalert2';
import { ImgCropperConfig, ImgCropperEvent, LyResizingCroppingImages, ImgCropperErrorEvent, ImgResolution } from '@alyle/ui/resizing-cropping-images';
import { LyTheme2, Platform } from '@alyle/ui';
import 'hammerjs';
import { UserService } from './../../services/user.service';
import { ToasterService } from '../../toaster.service';
import { RSAHelper } from '../../models/RSAHelper';

const styles = ({
  actions: {
    display: 'flex'
  },
  cropping: {
    maxWidth: '400px',
    height: '300px'
  },
  flex: {
    flex: 1
  },
  range: {
    textAlign: 'center',
    maxWidth: '500px',
    margin: '14px'
  }
});
 
@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
   
})
export class UserProfileComponent implements OnInit {
 
  
  public user_data: any;
  public division_data: any;
  public usertype_data: any;
  public usergroup_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public interactionData: object[];
  public usermasterForm: FormGroup;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  public ntUser: string = '';
  public ntUserData: any;
  public iseditmode: boolean = true;
  //@ViewChild('grid', { static: false })  public grid: GridComponent;
  public permission: number = 1;
  public desingation: string = '';
  public displayname: string = '';
  public role: string = '';
  public picture: string = '';
  public lastLogin: string = '';
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  //for Image
  croppedImage?: string;
  result: string;
  scale: number=0.1;
  classes = this.theme.addStyleSheet(styles);

  mySubscription: any;
  public selTab: boolean = true;
  @ViewChild(LyResizingCroppingImages, { static: false }) cropper: LyResizingCroppingImages;
  myConfig: ImgCropperConfig = {
    autoCrop: true,
    width: 250, // Default `250`
    height: 200, // Default `200`
    fill: '#ffffff', // Default transparent if type = png else #000,
    type: 'image/jpeg',
    //output: ImgResolution.OriginalImage // Default ImgResolution.Default
  };
  user: any = {};
  login_UserID: string; // number
    userTypeText: any;
  tenant_data: any=[];
  multiTenantList: any = [];
  tenantUno: number;
  division: any;
  userGroup:any
  constructor(public restApi: AdminApiService, public utilityService: UtilityService,
    private spinner: SpinnerVisibilityService, private theme: LyTheme2, private router: Router, private toaster: ToasterService, private userService: UserService, public RASHelper: RSAHelper) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;

    this.loadTenant();
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };


    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    /*this.desingation = this.user.desingation;*/
    /*this.displayname = this.user.displayname;*/
    /*this.role = this.user.role;*/
    /*this.division = this.user.division;*/
    /*this.userGroup = this.user.userGroup;*/
    /*this.picture = this.user.profilePicture;*/
    //this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    /*this.lastLogin = this.user.lastLogin;*/
    /*this.currentYear = this.user.currentYear;*/
    /*this.currentHalf = this.user.currentHalf;*/
    /*this.currentQuarter = this.user.currentQuarter;*/
    this.getDivisions();
    this.getUserType();
    this.getUserGroup();
    
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    
    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    else
      this.toolbar = ['Search', 'ExcelExport'];
    
    this.pageSettings = { pageSize: 20, pageSizes: true };
   // this.interactionData = DataUtil.distinct(this.data, 'id', true);

    this.loadUserMaster();
   // this.loadNTUserMaster();

    //this.getUserPermissionEntry(this.login_UserID);
  }

  // Get user list
  loadUserMaster() {
    let currPage = this;
    this.spinner.show();
    let inpValue = new usermaster();    
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = "1";
    inpValue.ntLogin = this.user.username;
    
    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          let rtnData: any = data;
          this.user_data = rtnData.data[0];

          currPage.getUserPermissionEntry(currPage.login_UserID);

          //this.user_data = data[0];

          //let multiTenant = this.user_data.multiTenant;
          //let userArr = multiTenant.split(",");
          //const mockDataset = [];
          //for (let i = 0; i < userArr.length; i++) {
          //  mockDataset[i] = {
              
          //    tenantUno: userArr[i],
          //    tenantName: this.getTenantName(userArr[i])
          //  };
          //}
          //this.multiTenantList = mockDataset;
        
        //this.userTypeText = this.usertype_data.filter(a => this.user_data[0].userTypeUno.includes(a.id))[0].name;
        this.pageAction = 'edit';
        this.usermasterForm = this.createFormGroup(this.user_data);
          this.spinner.hide();
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      }); 
  }

  getUserPermissionEntry(selectedUserUno: any) {
    
    this.spinner.show();
    let inpValue = new userpermission();
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = selectedUserUno;
    inpValue.enteredBy = this.login_UserID;
    //inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getUserPermission(inpValue)
      .subscribe(data => {
        
        let rtndata: any = data;
                
        const mockDataset = [];

        mockDataset[0] = {

          tenantUno: this.user_data.tenantUno,
          tenantName: this.getTenantName(this.user_data.tenantUno),
          divisionUno: this.user_data.divisionUno,
          divisionName: this.user_data.divisionNameEn,
          userTypeUno: this.user_data.userTypeUno,
          userTypeName: this.user_data.userTypeNameEn,
          userRoleUno: this.user_data.usergroupUno,
          userRoleName: this.user_data.usergroupEn
        };
        for (let i = 0; i < rtndata.length; i++) {
          mockDataset[i+1] = {
            tenantUno: rtndata[i].tenantUno,
            tenantName: rtndata[i].tenant,
            divisionUno: rtndata[i].divisionUno,
            divisionName: rtndata[i].divisionName,
            userTypeUno: rtndata[i].userTypeUno,
            userTypeName: rtndata[i].userType,
            userRoleUno: rtndata[i].userRoleUno,
            userRoleName: rtndata[i].userRole
          };
        }

        if (mockDataset.length > 0) {
          this.multiTenantList = mockDataset;
        } else {
          this.multiTenantList = [];
        }

        //this.multiTenantList = mockDataset;
        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  getTenantName(id: any) {
    var objTenant = this.tenant_data.filter(item => item.tenantUno == id);
    if (objTenant.length > 0) {
      return objTenant[0].tenantNameEn;
    } else
    { return ""; }
      
  }
  // Get user list
  loadNTUserMaster() {
    this.spinner.show();
    let inpValue = new usermaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = "1";
    
    this.restApi.getUserMasters(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        this.ntUserData = rtnData.data;
        //this.ntUserData = data;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  sendWelcomeEmail(useruno: any) {

  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getUserType() {
    this.usertype_data = [
      { id: 1, name: 'Administrator' },
      { id: 2, name: 'User' },
      { id: 3, name: 'SLA Admin' },
      { id: 4, name: 'SLA Coordinator' }
    ]
  }
  
  getUserGroup() {
    let inpValue = new usergroup();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    this.restApi.getUserGroups(inpValue)
      .subscribe(data => {
        this.usergroup_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

    //this.usergroup_data = [
     // { id: 1, name: 'User Group 1' },
      //{ id: 2, name: 'User Group 2' }
    //]
  }
  createFormGroup(data1: any): FormGroup {
    
    if (data1.userPhoto != null && data1.userPhoto != '' && data1.userPhoto != '/assets/img/user-default.png') {
      this.croppedImage = data1.userPhoto;
    }
    
    return new FormGroup({
      userUno: new FormControl(data1.userUno),
      ntUsername: new FormControl(data1.ntUsername, Validators.required),
      displayNameEn: new FormControl(data1.displayNameEn, Validators.required),
      displayNameAr: new FormControl(data1.displayNameAr, Validators.required),
      firstname: new FormControl(data1.firstname),
      lastname: new FormControl(data1.lastname),
      emailId: new FormControl(data1.emailId, Validators.email),
      designationEn: new FormControl(data1.designationEn),
      designationAr: new FormControl(data1.designationAr),
      userTypeUno: new FormControl(data1.userTypeUno, Validators.required),
      divisionUno: new FormControl(data1.divisionUno, Validators.required),
      usergroupUno: new FormControl(data1.usergroupUno, Validators.required),
      userPhoto: new FormControl(data1.userPhoto)
    });
  }


  RedirectToHome() {
    this.router.navigateByUrl('dashboard');
  }
  ValidateForm() {

    this.submitClicked = true;
    if (this.usermasterForm.valid) {
      let objdata = this.usermasterForm.value;
      this.AddEditUserMaster(objdata);
    } else {
       
    }

  }
  AddEditUserMaster(data1: any) {

    
    let objUser = new usermaster();
    objUser.actionType = this.pageAction;
    objUser.userUno = (this.pageAction == "add") ? 0 : data1.userUno;
    objUser.userUno = this.RASHelper.encryptWithPublicKey(objUser.userUno);
    objUser.ntUsername = this.utilityService.isStringNull(data1.ntUsername);
    objUser.displayNameEn = this.utilityService.isStringNull(data1.displayNameEn);
    objUser.displayNameAr = this.utilityService.isStringNull(data1.displayNameAr);
    objUser.emailId = this.utilityService.isStringNull(data1.emailId);
    objUser.firstname = this.utilityService.isStringNull(data1.firstname);
    objUser.lastname = this.utilityService.isStringNull(data1.lastname);
    objUser.designationEn = this.utilityService.isStringNull(data1.designationEn);
    objUser.designationAr = this.utilityService.isStringNull(data1.designationAr);
    objUser.userTypeUno = this.utilityService.isNumericNull(data1.userTypeUno);
    objUser.usergroupUno = this.utilityService.isNumericNull(data1.usergroupUno);
    objUser.divisionUno = this.utilityService.isNumericNull(data1.divisionUno);
    objUser.userPhoto = (this.croppedImage != null && this.croppedImage != '') ? this.croppedImage : '';

    //objUser.userUno = 2;
    objUser.tenantUno = "1";
    objUser.enteredBy = this.utilityService.isStringNull(this.login_UserID);
    
    this.restApi.addEditUserMaster(objUser)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Oops...', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Profile Updated');
          this.loadUserMaster();
          //Swal.fire({
          //  type: 'success',
          //  title: 'Profile Updated.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
         ///this.loadUserMaster();

        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  DeleteInteraction(data1: any) {

    let objUser = new usermaster();
   // objInteraction.actionType = this.pageAction;
    //objInteraction.interactionUno = data1[0].userUno;   
    objUser.userUno = this.RASHelper.encryptWithPublicKey('2');
    objUser.tenantUno = "1";
    
    this.restApi.deleteUserMaster(objUser)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
        //  Swal.fire('Oops...', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Deleted');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadUserMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
  toolbarClick(args: ClickEventArgs): void {
    
    if (args.item.id === 'grdData_excelexport') {
      //const excelExportProperties: ExcelExportProperties = {
      //  includeHiddenColumn: true,
      //  fileName: 'user_' + new Date().toLocaleDateString() + '.xlsx'
      //};
     // this.grid.excelExport(excelExportProperties);
    }
  }

  onCropped(e: ImgCropperEvent) {
    
    this.croppedImage = e.dataURL;
    
  }
  onloaded(e: ImgCropperEvent) {
    
  }
  onerror(e: ImgCropperErrorEvent) {
    
  }
  formatLabel(value: number | null) {
    if (!value) {
      return 0;
    }

    if (value >= 1) {
      return Math.round(value / 1) + '%';
    }

    return value;
  }
  //onSliderInputChange(event: MatSliderChange) {    
  //  this.scale =event.value;
  //}
  //public onFilteringNTUser: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['ntUsername', 'value']);
  //  query = (e.text !== '') ? query.where('ntUsername', 'startswith', e.text, true) : query;
  //  e.updateData(this.ntUserData, query);
  //};
  onchangeNTUser(e) {
    
    this.ntUser = (e.itemData != null) ? e.itemData.value : 0;
    //this.currentYear = this.yearUno;
   //if (!this.isStart) { this.loadKPIInbox(); }
  }
  onChangeTab(val: any) {
    this.spinner.show();

    let temp = this;
    setTimeout(function () {
      temp.spinner.hide();
    }, 700);


  }

  get ntUsername(): AbstractControl { return this.usermasterForm.get('ntUsername'); }
  get displayNameEn(): AbstractControl { return this.usermasterForm.get('displayNameEn'); }
  get displayNameAr(): AbstractControl { return this.usermasterForm.get('displayNameAr'); }

  //get firstname(): AbstractControl { return this.usermasterForm.get('firstname'); }
  //get lastname(): AbstractControl { return this.usermasterForm.get('lastname'); }
  get emailId(): AbstractControl { return this.usermasterForm.get('emailId'); }
  //get designationEn(): AbstractControl { return this.usermasterForm.get('designationEn'); }
  //get designationAr(): AbstractControl { return this.usermasterForm.get('designationAr'); }
  get userTypeUno(): AbstractControl { return this.usermasterForm.get('userTypeUno'); }
  get divisionUno(): AbstractControl { return this.usermasterForm.get('divisionUno'); }
  get usergroupUno(): AbstractControl { return this.usermasterForm.get('usergroupUno'); }

  loadTenant() {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('2');
    
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        
        this.tenant_data = data;
       
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  SwitchTenant(tenantUno: any,item:any) {
    
    var strTenant = '{"id":"' + 1 + '"}';
    localStorage.removeItem('switchTenant');
    localStorage.setItem('switchTenant', strTenant);
    this.userService.getTenantInfo(tenantUno,item,"");
    return false;
  }

  //getTenantInfo(tenantUno: number, item: any) {
  //  this.spinner.show();
  //  let inpValue = new tenant();
  //  inpValue.languageUno = 1033;
  //  inpValue.itemUno = tenantUno;
  //  inpValue.condition = 2;
  //  inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('1');

    
  //  this.restApi.getTenants(inpValue)
  //    .subscribe(data => {
        
  //      this.user = this.userService.getUserInfo();
  //      var isDigitalUser = (tenantUno == this.user.tenantDigitalUno) ? true : false;
  //      let tenantData: any = data;
  //      if (tenantData != null && tenantData.length > 0) {
  //        this.user.slaname = tenantData[0].slaName;
  //        this.user.siteHeading = tenantData[0].siteHeading;
  //        this.user.isDynamicEntry = (tenantData[0].isDynamicEntry == 1) ? 'true' : 'false';

  //        this.user.currentYear = tenantData[0].currentYear;
  //        this.user.currentHalf = tenantData[0].currentHalf;
  //        this.user.currentMonth = tenantData[0].currentMonth;
  //        this.user.currentQuarter = tenantData[0].currentQuarter;
  //        this.user.wellperformKPIRange = tenantData[0].wellPerformKPIRange;
  //      }
  //      this.userService.switchTenantConfiguration(tenantUno, isDigitalUser, item, "");

  //      //var struser = '{"id":"' + this.user.id + '","tenantDigitalUno":"' + this.user.tenantDigitalUno + '","tenantDigitalUser":"' + isDigitalUser + '","displayname":"' + this.user.displayname + '","username":"' + this.user.username + '","firstname":"' + this.user.firstname + '","lastname":"' + this.user.lastname + '","email":"' + this.user.email + '","role":"' + item.userTypeName + '","desingation":"' + this.user.desingation + '","division":"' + item.divisionName + '","divisionUno":"' + item.divisionUno + '","profilePicture":"' + this.user.profilePicture + '","currentYear":"' + this.user.currentYear + '","currentHalf":"' + this.user.currentHalf + '","currentQuarter":"' + this.user.currentQuarter + '","currentMonth":"' + this.user.currentMonth + '","versionNumber":"' + this.user.versionNumber + '","wellperformKPIRange":"' + this.user.wellperformKPIRange + '","lastLogin":"' + this.user.lastLogin + '","tenantUno":"' + tenantUno + '","isDynamicEntry":"' + this.user.isDynamicEntry + '","siteHeading":"' + this.user.siteHeading + '","slaname":"' + this.user.slaname + '","userroleType":"' + item.userTypeUno + '","userGroupUno":"' + item.userRoleUno + '","userGroup":"' + item.userRoleName + '"}';
  //      //localStorage.removeItem('userinfo');
  //      //localStorage.setItem('userinfo', struser);
  //      //// remove inbox filter:
  //      //let inboxstVal = 'inbox_filter_musherat_storage';
  //      //localStorage.removeItem(inboxstVal);

  //      //this.loadUserRights(this.login_UserID, item.userTypeUno);
  //      //setTimeout(() => {
          
  //      //  if (this.user.userroleType == 5 || this.user.userroleType == 6 || this.user.userroleType == 7 || this.user.userroleType == 8) {
  //      //    //this.router.navigate(['/benchmark-home']);

  //      //    window.location.href = "#/benchmark-home";
  //      //    window.location.reload();
  //      //  }
  //      //  else if (this.user.tenantUno == 6) {
  //      //    window.location.href = "bsc/dashboard";
  //      //  }
  //      //  else {
  //      //    window.location.href = "#/dashboard";
  //      //    window.location.reload();
  //      //    //this.router.navigate(['/dashboard']);
  //      //  }

  //      //}, 1000);
        
  //      this.spinner.hide();
  //    },
  //      (error) => {
  //        //Called when error
  //        this.spinner.hide();
  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)
  //      this.spinner.hide();
  //    });

  //  return false;
  //}

  onemptyClick() { return false; }

  //loadUserRights(userUno, userGroupUno) {


  //  let inpValue = new userrights();
  //  inpValue.languageUno = 1033;
  //  inpValue.condition = 1;
  //  inpValue.tenantUno = this.tenantUno;
  //  inpValue.userUno = userUno;
  //  inpValue.pageUno = 0;
  //  inpValue.usergroupUno = userGroupUno;

  //  this.restApi.getUserRights(inpValue)
  //    .subscribe(data => {
        
  //      var struserrights = JSON.stringify(data);
  //      localStorage.removeItem('userrights');
  //      localStorage.setItem('userrights', struserrights);

  //    },
  //      (error) => {
  //        //Called when error

  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)

  //    });
  //}
}

